export const chat_sv = {
  'send_suggestion_button_alert' : 'Skicka tidsförslag till ',
  'send_suggestion_header_alert' : 'Uppgradera ditt konto',
  'send_suggestion_message_alert' : 'För att skicka promenadförslag måste du uppgradera till Walking Talking PRO',
  'send_suggestion_linktext_alert' : 'Uppgradera',
  'could_not_load_messages' : 'Kunde inte hämta meddelanden',
  'could_not_send_message' : 'Kunde inte skicka meddelandet',
  'sent_a_suggestion' : 'Promenadförslag',
  'could_not_find_message' : 'Hittade inte detta meddelande',
  'chat_messages' : 'Meddelanden',
  'our_walks' : 'Våra promenader',
  'blocked_person' : 'Personen är blockerad',
  'send_walk_suggestion' : 'Skicka promenadförslag',
  'send_suggestion' : 'Skicka förslag',

  'from_you' : 'Du',
  'walk_was_removed' : 'Promenaden har tagits bort',
  'deleted' : 'Raderad',
  'you_accepted_time' : 'Du har accepterat tiden',
  'you_denied_time' : 'Du har nekat tiden',
  'waiting_on_response' : 'Väntar på svar',
  'other_accepted' : 'Promenaden har accepterats',
  'other_deny' : 'Promenaden har nekats',
  'go_to_walk' : 'Se promenaden',

  'you_have_cancelled_walk' : 'Promenaden ställdes in',
  'they_have_cancelled_walk' : 'Promenaden ställdes in',
  'has_booked_walk': 'Promenaden har bokats',

  'upcoming' : 'Kommande',
  'previous' : 'Tidigare',

  'error_could_not_load' : 'Kunde inte ladda chatten',
  'error_not_allowed_chat' : 'För att kunna chatta måste du vara vän med eller ha en bokad promenad med personen.',

  'sent_an_invite' : 'Promenadförslag',

  'walkInfo_today' : 'Promenad idag, kl.',
  'walkInfo_tomorrow': 'Promenad imorgon, kl.',
  'walkInfo_twodays' : 'Promenad i övermorgon, kl.',
  'walkInfo_in_days' : 'Promenad om ',
  'walkInfo_day' : ' dagar',
  'walkInfo_latest' : 'Senaste promenaden: '
}